import { threeDSConfig } from '@/config/adyen';
import AdyenCheckout from '@adyen/adyen-web';
import { useEffect, useRef, useState } from 'react';

export type UseThreeDSProps = {
  action: any;
  handleOnAdditionalDetails: (state: any) => void;
  isGiftcard?: boolean;
};

const useThreeDS = ({ action, handleOnAdditionalDetails, isGiftcard }: UseThreeDSProps) => {
  const [checkout, setCheckout] = useState(null);
  const componentRef = useRef<HTMLDivElement>(null);
  const isMounted = useRef(false);

  useEffect(() => {
    isMounted.current = true;
    const initThreeDS = async () => {
      const configuration = {
        ...threeDSConfig(isGiftcard),
        onAdditionalDetails: handleOnAdditionalDetails,
      };

      const checkout = await AdyenCheckout(configuration);
      setCheckout(checkout);
    };

    initThreeDS();

    return () => {
      isMounted.current = false;
    };
  }, []);

  useEffect(() => {
    if (!checkout || !isMounted.current) {
      return;
    }

    const component = checkout.createFromAction(action, { challengeWindowSize: '05' });
    component?.mount(componentRef?.current);

    return () => {
      if (checkout && component) component.unmount();
    };
  }, [checkout]);

  return { componentRef };
};

export default useThreeDS;
